module.exports = __webpack_public_path__ + "50d0fe9d6fe7ce7dc7f391683e56dbbb.png";